var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.1875H7.875C7.55625 0.1875 7.3125 0.43125 7.3125 0.75C7.3125 1.06875 7.55625 1.3125 7.875 1.3125H18C19.7625 1.3125 21.1875 2.7375 21.1875 4.5V20.25C21.1875 20.5688 21.4312 20.8125 21.75 20.8125C22.0688 20.8125 22.3125 20.5688 22.3125 20.25V4.5C22.3125 2.11875 20.3813 0.1875 18 0.1875Z",
    fill: "#85909F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 23.8125H16.875C18.225 23.8125 19.3125 22.725 19.3125 21.375V10.125C19.3125 9.80625 19.0688 9.5625 18.75 9.5625C18.4312 9.5625 18.1875 9.80625 18.1875 10.125V21.375C18.1875 22.1063 17.6062 22.6875 16.875 22.6875H4.875C4.14375 22.6875 3.5625 22.1063 3.5625 21.375V5.625C3.5625 4.89375 4.14375 4.3125 4.875 4.3125H14.4375V5.625C14.4375 6.975 15.525 8.0625 16.875 8.0625H18.75C19.0688 8.0625 19.3125 7.81875 19.3125 7.5C19.3125 6.35625 18.8625 5.26875 18.0563 4.44375C17.2313 3.6375 16.1438 3.1875 15 3.1875H4.875C3.525 3.1875 2.4375 4.275 2.4375 5.625V21.375C2.4375 22.725 3.525 23.8125 4.875 23.8125ZM15.5625 4.36875C16.2 4.48125 16.7812 4.78125 17.25 5.25C17.7188 5.71875 18.0187 6.3 18.1312 6.9375H16.875C16.1438 6.9375 15.5625 6.35625 15.5625 5.625V4.36875Z",
    fill: "#85909F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.48b3f1e14f5c4f40f5c364130a35536b.svg";
export { ForwardRef as ReactComponent };